import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "theme", "icon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { IconChevronRight12, UIText2 } from '@cian/ui-kit';
import styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var themeMap = {
  primary: {
    textColor: 'white_100',
    iconColor: 'white_100'
  }
};
export var SupportContactsWidgetItemLink = function SupportContactsWidgetItemLink(_ref) {
  var children = _ref.children,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'primary' : _ref$theme,
    Icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var colors = themeMap[theme];
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-no-target-blank
    _jsxs("a", _objectSpread(_objectSpread({}, rest), {}, {
      className: styles.contact,
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        color: colors.iconColor
      }), /*#__PURE__*/_jsx(UIText2, {
        color: colors.textColor,
        children: children
      }), /*#__PURE__*/_jsx(IconChevronRight12, {
        color: colors.iconColor
      })]
    }))
  );
};
SupportContactsWidgetItemLink.displayName = 'PopupItemLink';